import { ElementType, IElement } from '../../../models/Element';

export type PluginRightImageHighlightInfo = IElement & {
  image: string;
  image_alt: string;
  heading: string;
  description: string;
};

export const defaultPluginRightImageHighlightInfo: PluginRightImageHighlightInfo =
  {
    id: 0,
    name: ElementType.PLUGIN_RIGHT_IMAGE_HIGHLIGHT_INFO,
    image: '',
    image_alt: '',
    heading: 'Als makelaar kun je niet zonder deze plugin',
    description:
      'De "WordPress Makelaars plugin" is onmisbaar voor de makelaar. Niet alleen toont de plugin het actuele aanbod, ook scoort de website beter in zoekmachines zoals Google. Omdat alle objecten op de website staan, worden deze door zoekmachines beter geindexeerd.',
  };
